<template>
  <div>
    <div v-if="!activeRoute">
      <v-app id="keep">
        <v-progress-linear class="mb-4" height="5" indeterminate color="blue darken-2"></v-progress-linear>
      </v-app>
    </div>
    <component v-else :is="activeRoute"></component>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import LanguageApi from "@/core/modules/LanguageApi";
import { ref } from "@vue/composition-api";

export default {
  name: "App",
  props: {
    source: String
  },
  metaInfo() {
    return {
      title: "Admin Panel",
      titleTemplate: `%s | ${this.titleDescription}`
    };
  },
  provide() {
    return {
      isDark: this.$vuetify.theme.isDark,
      webSiteUrl: this.webSiteUrl
    };
  },
  data() {
    return {
      langApi: new LanguageApi(),
      loginStatus: false,
      loginOverlay: false,
      authUser: "",
      activeRoute: ""
    };
  },
  setup() {
    const webSiteUrl = ref(process.env.VUE_APP_SITE_URL);

    return {
      webSiteUrl
    };
  },
  computed: {
    ...mapState({
      activeBreadCrumbs: state => state.activeBreadCrumbs
    }),
    titleDescription() {
      return this.activeBreadCrumbs.map(o => o.text).join(" > ");
    }
  },
  methods: {
    setStatus() {
      this.$nextTick(() => {
        /**
         * Sistem loadingStatus'u set et
         */
        window.onload = () => {
          this.$store.commit("setLoadingStatus", false);
        };
        this.$store.commit("setLoadingStatus", false);
      });
    }
  },
  created() {
    let appProcess = [Promise];
    axios.interceptors.response.use(response => {
      if (response.data.status !== 401) {
        return response;
      } else {
        this.$store.dispatch("User/UserLogin/authLogout");
        this.$router.go("login");
        return response;
      }
    });

    this.$components = {
      ActivePanel: () => import("@/views/Login.vue")
    };

    const defaultLang = 'en';

    /**
     * Set default lang for vuetify
     *
     * @type {string}
     */
    this.$vuetify.lang.current = defaultLang;

    /**
     * Panel ilk açıldığında default verileri
     * istek ile getirip localStorage'e at
     */
    const setPanelLanguage = new Promise(async resolve => {
      const storedTranslations = await this.langApi.getAllLanguages();

      if (Object.keys(storedTranslations).length === 0) {
        // Eğer veritabanında çeviri verisi yoksa, API'den çekerek veritabanına kaydet
        return this.$store.dispatch("Language/setLang").then(({ data }) => {
          this.langApi.setPanelLanguages(data);
          this.$i18n.setLocaleMessage(defaultLang, data);
          resolve(data)
        });
      } else {
        // Eğer veritabanında çeviri verisi varsa, doğrudan i18n mesajlarını güncelle
        this.$i18n.setLocaleMessage(defaultLang, storedTranslations);
        resolve(storedTranslations)
      }
    });

    appProcess.push(setPanelLanguage);

    /**
     * Token giriliyse bilgiyi authUser'a aktar
     */
    if (this.$store.getters["User/UserLogin/isAuthenticated"]) {
      appProcess.push(
        this.$store.dispatch("User/UserLogin/parseToken", this.$store.state.User.UserLogin.token).then(() => {
          this.authUser = this.$store.getters.getAuthUser;
        })
      );
    }

    Promise.all(appProcess).then(() => {
      this.activeRoute = () => import(!this.$store.getters["User/UserLogin/isAuthenticated"] ? "@/views/Login.vue" : "@/views/Panel.vue");
    });
  },
  mounted() {
    this.setStatus();
  },
  updated() {
    this.setStatus();
  },

  watch: {
    $route(current) {
      if (current.name !== "Login") {
        localStorage.setItem("last-route", current.path);
      }
    }
  }
};
</script>

<style lang="scss">
/**
    .snotify düzenlemeleri
  */
@import "~vue-snotify/styles/material";

.snotify {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
}

.snotify .snotifyToast__inner {
  padding: 10px 65px 10px 15px;
}
</style>

<style>
#keep.light {
  background-color: #eee;
}

#keep .v-navigation-drawer__border {
  display: none;
}

.v-avatar {
  min-width: auto !important;
}
</style>
